import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/San-Diego.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Elevating San Diego Businesses with Next-Gen Mobile Solutions
            </h2>
            <p>
              As the premier mobile app developers in San Diego, TekRevol is
              committed to elevating local businesses through next-generation
              mobile solutions.
            </p>
            <p>
              We understand that in the dynamic landscape of San Diego, staying
              ahead requires innovative strategies and cutting-edge technology.
              That's where our expertise as the leading app development company
              in San Diego comes into play.
            </p>
            <p>
              Our team of dedicated professionals thrives on the challenges
              posed by the vibrant San Diego business environment. We create
              mobile apps that not only meet your business needs but also exceed
              your customers' expectations. Our solutions are designed to
              enhance user experiences, boost brand engagement, and drive
              revenue growth.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
